module.exports = __webpack_public_path__ + "img/i-filter-white.46d190f1.svg";